<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="edit()">Edit Gift</button>
                </div>
            </div>
            <div class="table-responsive" v-if="gift">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>GiftId</th>
                        <td>{{gift.userGiftId}}</td>
                    </tr>
                    <tr>
                        <th>Gift Code</th>
                        <td>{{gift.gifteeUuid}}</td>
                    </tr>
                  <tr>
                    <th>Expiry Date</th>
                    <td>{{gift.trialEndDateCustomFmt}}</td>
                  </tr>
                    <tr>
                        <th>corporationId</th>
                        <td>{{gift.corporationName}}</td>
                    </tr>
                  <tr>
                    <th>Welcome Message</th>
                    <td>{{gift.welcomeMessage}}</td>
                  </tr>
                  <tr>
                    <th>Redeem Button Label</th>
                    <td>{{gift.button_label_01}}</td>
                  </tr>
                  <tr>
                    <th>Gift Pacage Description </th>
                    <td>{{gift.signupGiftDesc}}</td>
                  </tr>
                  <tr>
                    <th>Panel Title </th>
                    <td>{{gift.panelHeading1}}</td>
                  </tr>
                  <tr>
                    <th>Panel Description </th>
                    <td>{{gift.panelHeading2}}</td>
                  </tr>
                  <tr>
                    <th>Default Landing Page </th>
                    <td>{{gift.landingPage}}</td>
                  </tr>
                  <tr>
                    <th>Skip Interest Page after Singup </th>
                    <td v-if="gift.skipInterestPage.toString() === '1'">Yes</td>
                    <td v-if="gift.skipInterestPage.toString() !== '1'">No</td>
                  </tr>
                  <tr>
                    <th>Validate User after Singup </th>
                    <td v-if="gift.preValidate.toString() === '1'">Yes</td>
                    <td v-if="gift.preValidate.toString() !== '1'">No</td>
                  </tr>
                  <tr>
                    <th>Show Trial Expiry Message on Profile Page </th>
                    <td v-if="gift.trialExpiryMsgFlag.toString() === '1'">Yes</td>
                    <td v-if="gift.trialExpiryMsgFlag.toString() !== '1'">No</td>
                  </tr>
                  <tr>
                    <th>Panel Bullet 1 </th>
                    <td>{{gift.panelBullet1}}</td>
                  </tr>
                  <tr>
                    <th>Panel Bullet 2 </th>
                    <td>{{gift.panelBullet2}}</td>
                  </tr>
                  <tr>
                    <th>Panel Bullet 3 </th>
                    <td>{{gift.panelBullet3}}</td>
                  </tr>
                  <tr>
                    <th>Panel Bullet 4 </th>
                    <td>{{gift.panelBullet4}}</td>
                  </tr>
                  <tr>
                    <th>Panel Bullet 5 </th>
                    <td>{{gift.panelBullet5}}</td>
                  </tr>
                  <tr>
                    <th>Panel Bullet 6 </th>
                    <td>{{gift.panelBullet6}}</td>
                  </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'GiftDetails',
        components: {
            LTable,
        },
        created (){
        this.$store.dispatch('GET_SELECTED_GIFT', this.$route.params.id)
    },
    data () {
        return { }
    },
    methods: {
        edit(){
            this.$router.push({ name: 'EditGift', params: { id: this.$route.params.id}})
        },
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        }
    },
    computed: {
        ...mapGetters([ 'selectedGift']),
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        },
        gift(){
            return this.selectedGift
        }

    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Gifts/GiftDetails.vue